import React from "react";
import { useTheme } from "styled-components";

interface TruckIconProps {
  fill: string;
}

export const TruckIcon = ({ fill }: TruckIconProps): JSX.Element => {
  const theme = useTheme();
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      fill={fill}
      width={theme.sizes.xxl}
      height={theme.sizes.xxl}
      viewBox="0 0 48 48"
      enableBackground="new 0 0 48 48"
      xmlSpace="preserve"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="pictogram">
        <path
          d="M45,22.937h-5.117l-0.891-7.124L38,14.937h-8v-3l-1-1H3l-1,1v21l1,1h4.095C7.536,36.247,9.564,38,12,38
        s4.464-1.753,4.905-4.063H29h3.095C32.536,36.247,34.564,38,37,38s4.464-1.753,4.905-4.063H45l1-1v-9L45,22.937z M37.117,16.937
        l0.75,6H30v-6H37.117z M12,36c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S13.654,36,12,36z M12,28
        c-2.392,0-4.391,1.69-4.881,3.938H4v-19h24v3v8v8H16.881C16.391,29.69,14.392,28,12,28z M37,36c-1.654,0-3-1.346-3-3s1.346-3,3-3
        s3,1.346,3,3S38.654,36,37,36z M44,31.937h-2.119C41.391,29.69,39.392,28,37,28s-4.391,1.69-4.881,3.938H30v-7h14V31.937z"
        />
      </g>
      <g id="grid" display="none">
        <g display="inline">
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="0"
            x2="48"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="47"
            y1="0"
            x2="47"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="46"
            y1="0"
            x2="46"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="45"
            y1="0"
            x2="45"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="44"
            y1="0"
            x2="44"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="43"
            y1="0"
            x2="43"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="42"
            y1="0"
            x2="42"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="41"
            y1="0"
            x2="41"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="40"
            y1="0"
            x2="40"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="39"
            y1="0"
            x2="39"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="38"
            y1="0"
            x2="38"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="37"
            y1="0"
            x2="37"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="36"
            y1="0"
            x2="36"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="35"
            y1="0"
            x2="35"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="34"
            y1="0"
            x2="34"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="33"
            y1="0"
            x2="33"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="32"
            y1="0"
            x2="32"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="31"
            y1="0"
            x2="31"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="30"
            y1="0"
            x2="30"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="29"
            y1="0"
            x2="29"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="28"
            y1="0"
            x2="28"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="27"
            y1="0"
            x2="27"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="26"
            y1="0"
            x2="26"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="25"
            y1="0"
            x2="25"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="24"
            y1="0"
            x2="24"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="23"
            y1="0"
            x2="23"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="22"
            y1="0"
            x2="22"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="21"
            y1="0"
            x2="21"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="20"
            y1="0"
            x2="20"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="19"
            y1="0"
            x2="19"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="18"
            y1="0"
            x2="18"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="17"
            y1="0"
            x2="17"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="16"
            y1="0"
            x2="16"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="15"
            y1="0"
            x2="15"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="14"
            y1="0"
            x2="14"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="13"
            y1="0"
            x2="13"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="12"
            y1="0"
            x2="12"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="11"
            y1="0"
            x2="11"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="10"
            y1="0"
            x2="10"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="9"
            y1="0"
            x2="9"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="8"
            y1="0"
            x2="8"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="7"
            y1="0"
            x2="7"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="6"
            y1="0"
            x2="6"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="5"
            y1="0"
            x2="5"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="4"
            y1="0"
            x2="4"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="3"
            y1="0"
            x2="3"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="2"
            y1="0"
            x2="2"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="1"
            y1="0"
            x2="1"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="0"
            y1="0"
            x2="0"
            y2="48"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="0"
            x2="0"
            y2="0"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="1"
            x2="0"
            y2="1"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="2"
            x2="0"
            y2="2"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="3"
            x2="0"
            y2="3"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="4"
            x2="0"
            y2="4"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="5"
            x2="0"
            y2="5"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="6"
            x2="0"
            y2="6"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="7"
            x2="0"
            y2="7"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="8"
            x2="0"
            y2="8"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="9"
            x2="0"
            y2="9"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="10"
            x2="0"
            y2="10"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="11"
            x2="0"
            y2="11"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="12"
            x2="0"
            y2="12"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="13"
            x2="0"
            y2="13"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="14"
            x2="0"
            y2="14"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="15"
            x2="0"
            y2="15"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="16"
            x2="0"
            y2="16"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="17"
            x2="0"
            y2="17"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="18"
            x2="0"
            y2="18"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="19"
            x2="0"
            y2="19"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="20"
            x2="0"
            y2="20"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="21"
            x2="0"
            y2="21"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="22"
            x2="0"
            y2="22"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="23"
            x2="0"
            y2="23"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="24"
            x2="0"
            y2="24"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="25"
            x2="0"
            y2="25"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="26"
            x2="0"
            y2="26"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="27"
            x2="0"
            y2="27"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="28"
            x2="0"
            y2="28"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="29"
            x2="0"
            y2="29"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="30"
            x2="0"
            y2="30"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="31"
            x2="0"
            y2="31"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="32"
            x2="0"
            y2="32"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="33"
            x2="0"
            y2="33"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="34"
            x2="0"
            y2="34"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="35"
            x2="0"
            y2="35"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="36"
            x2="0"
            y2="36"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="37"
            x2="0"
            y2="37"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="38"
            x2="0"
            y2="38"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="39"
            x2="0"
            y2="39"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="40"
            x2="0"
            y2="40"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="41"
            x2="0"
            y2="41"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="42"
            x2="0"
            y2="42"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="43"
            x2="0"
            y2="43"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="44"
            x2="0"
            y2="44"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="45"
            x2="0"
            y2="45"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="46"
            x2="0"
            y2="46"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="47"
            x2="0"
            y2="47"
          />
          <line
            fill="none"
            stroke="#00AEEF"
            strokeWidth="0.05"
            strokeMiterlimit="10"
            x1="48"
            y1="48"
            x2="0"
            y2="48"
          />
        </g>
      </g>
    </svg>
  );
};
